import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import Slider from 'react-slick'
import './PropertyManagement.scss';

const GallerySlider = (props) => {
    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                 settings: {
                        slidesToShow: 1.25,
                        slidesToScroll: 1.25,
                       
                    }
            },
            {
                breakpoint: 991,
                 settings: {
                    slidesToShow: 1.92,
                    slidesToScroll: 1.92,
                       
                    }
            },
            {
                breakpoint: 1200,
                 settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1.92,
                       
                    }
            },
            {
                breakpoint: 3000,
                 settings: {
                        slidesToShow: 2.33,
                        slidesToScroll: 2,
                       
                    }
            }
        ]
    };
    return (
        <div className="property-management bg-transparent">
            <div className='gallery-silder pt-0'>
                <Slider className="slick-arrow top-50" {...settings}>
                    {props?.images?.map((item, index) =>(
                        <div className='img-zoom' key={index}>
                            <div>
                                <GatsbyImage
                                    image={getImage(item?.url_sharp)}
                                    alt={item?.url?.alternativeText ? item?.url?.alternativeText : "tlc Estate Agents in London"}
                                    className="h-100 w-100" 
                                />
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>              
    );
}

export default GallerySlider;
